module.exports = __webpack_public_path__ + "img/TitlingGothicFBCond-Bold.d85e66d2.svg";